// Structurally typed (not imported from merchant-api/types) to avoid a circular dependency
// between odfunctions and merchant-api.
export type FormattableAddress = {
  city: string;
  lines: string[];
  postalCode: string;
  state: string;
};

export function formatAddress(address: FormattableAddress): string {
  const street = address?.lines.join(', ');
  return `${street}, ${address?.city}, ${address?.state} ${address?.postalCode}`
}
